exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".description[data-v-12137eec] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.description[data-v-12137eec] {\n    justify-content: flex-start;\n    margin-top: 2em;\n}\n}\n@media only screen and (min-width: 560px) and (max-width: 759px) {\n.description[data-v-12137eec] {\n    padding-left: 18% !important;\n    padding-right: 18% !important;\n    justify-content: flex-start;\n    margin-top: 2em;\n}\n}\n", ""]);

// exports
